import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageModal from '../LanguageModal';
import './Header.css';

const getCurrentLanguageCode = (lang: string) => {
  switch (lang) {
    case 'ja': return 'JP';
    case 'en': return 'EN';
    case 'zh-CN': return 'ZHC';
    case 'zh-TW': return 'ZHT';
    default: return 'JP';
  }
};

const Header = (): JSX.Element => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const { i18n } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    setIsLanguageModalOpen(false);
  };

  return (
    <header id="header">
      <div className="header-container">
        <div className="logo">
          <img src="/images/logo.png" alt="BugeiScissors Logo" className="logo-image" />
        </div>
        <div className="header-actions">
          <button
            className="language-switcher"
            onClick={() => setIsLanguageModalOpen(true)}
            aria-label="言語切り替え"
          >
            {getCurrentLanguageCode(i18n.language)}
          </button>
     
     
          <button
            className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="メニュー"
            style={{ zIndex: 2001 }}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
     
        </div>
      </div>

      {/* オーバーレイとメニュー */}
      <div className={`menu-overlay${isMenuOpen ? ' show' : ''}`} onClick={closeMenu}></div>
      <nav className={`nav${isMenuOpen ? ' show' : ''}`}>
        <ul className="nav-list">
          <li><a href="/">ホーム</a></li>
          <li><a href="/products">商品一覧</a>
            <div className="sub-nav-list-container">
              <li><a className="sub-nav-list" href="/products/#original">オリジナル</a></li>
              <li><a className="sub-nav-list" href="/products/#thinning">セニング</a></li>
              <li><a className="sub-nav-list" href="/products/#standard">定番</a></li>
              <li><a className="sub-nav-list" href="/products/#custom">オーダーメイド</a></li>
            </div>
          </li>
          <li><a href="/sharpening">研ぎ</a></li>
          <li><a href="/support">武芸サポート</a></li>
          <li><a href="/contact">お問い合わせ</a></li>
        </ul>
      </nav>
      
      {/* 言語モーダル */}
      <LanguageModal
        isOpen={isLanguageModalOpen}
        onClose={() => setIsLanguageModalOpen(false)}
        currentLanguage={i18n.language}
        onLanguageChange={handleLanguageChange}
      />
    </header>
  );
};

export default Header;
